<template>
    <div class="d-flex justify-center align-center flex-column">
        <vue-headful :title="$t('title_ranking')" description="title" />
        <v-container fluid>
            <v-row class="ma-0">
                <TopBar />
            </v-row>
            <v-card class="px-2 px-md-8 border-radius-2 position-relative" elevation="0">
                <v-row class="title-row">
                    <v-col cols="auto" class="icon-title">
                        <v-img
                            :src="require('@/assets/img/icons/icon-ranking.png')"
                            height="135"
                            width="135"
                        ></v-img>
                    </v-col>
                    <v-col cols="auto" class="text-title text-left">
                        <h2 class="title-carousel">{{ $t('home.ranking') }}</h2>
                        <h3 class="subtitle-carousel">{{ $t('home.ranking_subtitle') }}</h3>
                    </v-col>
                </v-row>
                <div class="d-flex justify-center align-center">
                    <OptionPanel />
                </div>
                <v-row class="pa-0">
                    <v-col cols="12" class="pa-0">
                        <v-card min-height="500" elevation="0">
                            <MainContent :ranking_data="rankingData" v-if="rankingData" />
                            <v-overlay absolute :value="!rankingData" opacity="0">
                                <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    size="150"
                                    :width="15"
                                />
                            </v-overlay>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue';

import RankingService from '@/services/ranking'

import TopBar from '@/components/home/TopBar.vue'
import MainContent from '@/components/ranking/MainContent.vue'
import OptionPanel from '@/components/ranking/OptionPanel.vue'

import AnalyticEventsMixin from "../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    mixins: [AnalyticEventsMixin],
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
            school: (state) => state.userData.user.school,
        }),
    },
    components: {
        TopBar,
        MainContent,
        OptionPanel,
    },
    data() {
        return {
            rankingData: null,
        }
    },
    methods: {
        ...mapActions(['setRankingMode']),
    },
    async mounted() {
        const response = await RankingService.getRankings(this.school.id).catch((error) => {
            Sentry.captureException(error)
            this.$modal.loadError()
        })
        if (!response) {
            this.$modal.loadError()
            return
        }
        this.rankingData = response.content
        this.setRankingMode('school')
        this.createAnalyticEvent(AnalyticEventTypes.GoToRanking)
    },
}
</script>
<style lang="scss" scoped>
.title-carousel{
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 100%;
}
.subtitle-carousel{
    color: #64748B;
    font-size: 1rem;
    font-weight: 400;
}
.title-row{
    margin-top: 70px;
}
.icon-title{
    position: absolute;
    left: -10px;
    top: -12px;
}
.text-title{
    position: absolute;
    left: 90px;
    top: 15px;
}
</style>